import React, { FC, createContext, useContext } from 'react';

const Context = createContext<Location | null>(null);

interface Props {
  value: Location;
}

const LocationContext: FC<Props> = ({ value, children }) => {
  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

function useLocation() {
  return useContext(Context);
}

export default LocationContext;
export { useLocation };